import {NetworkAPIVersion, NetworkParamType} from './network.utils';

export default {
  verifyEmail: {
    url: 'member/verify-email/',
    apiVersion: NetworkAPIVersion.v1_version,
    method: 'post',
    params: {
      token: [NetworkParamType.string],
    },
  },
  verifyEmailCode: {
    url: 'member/verify-email-code/',
    apiVersion: NetworkAPIVersion.v1_version,
    method: 'post',
    params: {
      code: [NetworkParamType.string],
    },
  },
  resendVerifyEmail: {
    url: 'member/resend-verify-email/',
    apiVersion: NetworkAPIVersion.v1_version,
    authorization: true,
    method: 'post',
  },
};
